export default [
  {
    path: '/social-visits/home',
    name: 'social-visits-home',
    meta: {
      protected: true,
      requiresPermission: ['allow_social_visits'],
      pageTitle: 'Social Visits',
    },
    component: () => import('@/views/socialVisits/SocialVisitsHome.vue'),
  },
  {
    path: '/social-visits',
    name: 'social-visits',
    meta: {
      protected: true,
      requiresPermission: ['allow_social_visits'],
      pageTitle: 'Social Visits',
    },
    component: () => import('@/views/socialVisits/SocialVisits.vue'),
  },
  {
    path: '/social-visits/:id/details',
    name: 'social-visit-details',
    meta: {
      protected: true,
      requiresPermission: ['allow_social_visits'],
      pageTitle: 'Social Visit Details',
    },
    component: () => import('@/views/socialVisits/SocialVisitDetails.vue'),
  },
  {
    path: '/social-visits/book',
    name: 'book-social-visit',
    meta: {
      protected: true,
      requiresPermission: ['allow_social_visits'],
      pageTitle: 'Book Social Visit',
    },
    component: () => import('@/views/socialVisits/BookSocialVisit.vue'),
  },
  {
    path: '/social-visits/requested',
    name: 'requested-visits',
    meta: {
      protected: true,
      requiresPermission: ['allow_social_visits'],
      pageTitle: 'Social Visits',
      status: 'Requested',
    },
    component: () => import('@/views/socialVisits/SocialVisits.vue'),
  },
  {
    path: '/social-visits/awaiting-confirmation',
    name: 'awaiting-visits',
    meta: {
      protected: true,
      requiresPermission: ['allow_social_visits'],
      pageTitle: 'Social Visits',
      status: 'AwaitingConfirmation',
    },
    component: () => import('@/views/socialVisits/SocialVisits.vue'),
  },
  {
    path: '/social-visits/approved',
    name: 'approved-visits',
    meta: {
      protected: true,
      requiresPermission: ['allow_social_visits'],
      pageTitle: 'Social Visits',
      status: 'Approved',
    },
    component: () => import('@/views/socialVisits/SocialVisits.vue'),
  },
  {
    path: '/social-visits/completed',
    name: 'completed-visits',
    meta: {
      protected: true,
      requiresPermission: ['allow_social_visits'],
      pageTitle: 'Social Visits',
      status: 'Completed',
    },
    component: () => import('@/views/socialVisits/SocialVisits.vue'),
  },
  {
    path: '/social-visits/cancelled',
    name: 'cancelled-visits',
    meta: {
      protected: true,
      requiresPermission: ['allow_social_visits'],
      pageTitle: 'Social Visits',
      status: 'Cancelled',
    },
    component: () => import('@/views/socialVisits/SocialVisits.vue'),
  },
  {
    path: '/social-visits/rejected',
    name: 'rejected-visits',
    meta: {
      protected: true,
      requiresPermission: ['allow_social_visits'],
      pageTitle: 'Social Visits',
      status: 'Rejected',
    },
    component: () => import('@/views/socialVisits/SocialVisits.vue'),
  },
  {
    path: '/social-visits/print',
    name: 'print-social-visits',
    meta: {
      protected: true,
      requiresPermission: ['allow_social_visits'],
      pageTitle: 'Print Social Visits',
    },
    component: () => import('@/views/socialVisits/PrintSocialVisits.vue'),
  },
];
